import React, { useState, useEffect } from "react";
import { withStyles } from "@material-ui/core/styles";
import {
  Grid,
  Box,
  Typography,
  Card,
  CardMedia,
  Container,
  Tab,
} from "@material-ui/core";
import { TabContext, TabList, TabPanel } from "@material-ui/lab";
import { PhoneAndroidOutlined, TabletAndroid } from "@material-ui/icons";
import { useTranslation } from "react-i18next";
import { useTheme } from "@material-ui/core/styles";

import styles from "./ImagePreviewStyles";

const ImagePreviewContent = ({
  classes,
  imageUrl,
  imageFile,
  phoneWidth,
  phoneHeight,
  tabletWidth,
  tabletHeight,
  titleOneImageInfo,
  titleTwoImageInfo,
  twoPreviewsPerTab = false,
  backgoundSize = "cover",
}) => {
  const { t } = useTranslation();
  const [selectedTab, setSelectedTab] = useState("1");
  const theme = useTheme();

  const getImageUrl = () => {
    if (imageFile) {
      return URL.createObjectURL(imageFile);
    }
    return imageUrl;
  };

  return (
    <Grid
      item
      xs={12}
      direction="column"
      style={{
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        width: "100%",
        backgroundColor: "#e6e9f0",
        borderRadius: 12,
        padding: 0,
      }}
    >
      <TabContext value={selectedTab}>
        <Box
          sx={{
            borderBottom: 1,
            borderColor: "divider",
            backgroundColor: "#f0f2f7",
            width: "100%",
            borderRadius: "12px 12px 0 0",
          }}
        >
          <TabList
            style={{ width: "100%" }}
            onChange={(event, newValue) => setSelectedTab(newValue)}
          >
            <Tab
              style={{ width: "50%", fontSize: 7 }}
              icon={<PhoneAndroidOutlined style={{ height: 15, width: 15 }} />}
              label={
                <span style={{ fontSize: "10px" }}>
                  {t("newTour.telephone")}
                </span>
              }
              value="1"
            />
            <Tab
              style={{ width: "50%" }}
              icon={<TabletAndroid style={{ height: 15, width: 15 }} />}
              label={
                <span style={{ fontSize: "10px" }}>{t("newTour.tablet")}</span>
              }
              value="2"
            />
          </TabList>
        </Box>
        <TabPanel value="1">
          <Container className={titleOneImageInfo ? classes.cardContainer : ""}>
            <Typography className={classes.imageInfos} gutterBottom>
              {titleOneImageInfo}
            </Typography>
            <Card
              className={classes.imageCardBackground}
              style={{
                width: phoneWidth ? phoneWidth / 4 : 411 / 4,
                height: phoneHeight ? phoneHeight / 4 : 794 / 4,
                [theme.breakpoints.up("md")]: {
                  width: phoneWidth ? phoneWidth / 3 : 411 / 3,
                  height: phoneHeight ? phoneHeight / 3 : 794 / 3,
                },
              }}
            >
              <CardMedia
                className={classes.imageCardMedia}
                image={getImageUrl()}
                title="Image Preview"
                style={{
                  backgroundSize: backgoundSize,
                }}
              />
            </Card>
          </Container>
          {/* {twoPreviewsPerTab && (
            <Container
              className={titleTwoImageInfo ? classes.cardContainer : ""}
            >
              <Typography className={classes.imageInfos} gutterBottom>
                {titleTwoImageInfo}
              </Typography>
              <Card
                className={classes.imageCardBackgroundInList}
                style={{
                  width: phoneWidth ? phoneWidth / 4 : 411 / 4,
                  height: phoneHeight ? phoneHeight / 4 : 794 / 4,
                  [theme.breakpoints.up("md")]: {
                    width: phoneWidth ? phoneWidth / 3 : 411 / 3,
                    height: phoneHeight ? phoneHeight / 3 : 794 / 3,
                  },
                }}
              >
                <CardMedia
                  className={classes.imageCardMedia}
                  image={getImageUrl()}
                  title="Image Preview"
                  style={{
                    backgroundSize: backgoundSize,
                  }}
                />
              </Card>
            </Container>
          )} */}
        </TabPanel>
        <TabPanel value="2">
          <Container className={titleOneImageInfo ? classes.cardContainer : ""}>
            <Typography className={classes.imageInfos} gutterBottom>
              {titleOneImageInfo}
            </Typography>
            <Card
              className={classes.imageCardBackgroundTab}
              style={{
                width: tabletWidth ? tabletWidth / 8 : 1024 / 8,
                height: tabletHeight ? tabletHeight / 8 : 1310 / 8,
                [theme.breakpoints.up("md")]: {
                  width: tabletWidth ? tabletWidth / 4 : 1024 / 4,
                  height: tabletHeight ? tabletHeight / 4 : 1310 / 4,
                },
              }}
            >
              <CardMedia
                className={classes.imageCardMedia}
                image={getImageUrl()}
                title="Image Preview"
                style={{
                  backgroundSize: backgoundSize,
                }}
              />
            </Card>
          </Container>
          {/* {twoPreviewsPerTab && (
            <Container
              className={titleTwoImageInfo ? classes.cardContainer : ""}
            >
              <Typography className={classes.imageInfos} gutterBottom>
                {titleTwoImageInfo}
              </Typography>
              <Card
                className={classes.imageCardBackgroundInListTab}
                style={{
                  width: tabletWidth ? tabletWidth / 8 : 1024 / 8,
                  height: tabletHeight ? tabletHeight / 8 : 1310 / 8,
                  [theme.breakpoints.up("md")]: {
                    width: tabletWidth ? tabletWidth / 4 : 1024 / 4,
                    height: tabletHeight ? tabletHeight / 4 : 1310 / 4,
                  },
                }}
              >
                <CardMedia
                  className={classes.imageCardMedia}
                  image={getImageUrl()}
                  title="Image Preview"
                  style={{
                    backgroundSize: backgoundSize,
                  }}
                />
              </Card>
            </Container>
          )} */}
        </TabPanel>
      </TabContext>
    </Grid>
  );
};

export default withStyles(styles)(ImagePreviewContent);
